import React, { PropsWithChildren } from 'react';

import {  TouchableOpacity, View } from 'react-native';


interface HeaderSideProps extends PropsWithChildren {
    position : 'left' | 'right',
    topPosition: number,
    sidePosition: number,
    onPress: () => void,
}
export const SIZE_TOP_BAR = 48;
export const HeaderSide = ({ position, sidePosition,topPosition, onPress, children}: HeaderSideProps) => {



  return(
    <View
      style={[{
        top:topPosition,
        zIndex:10,
        position:'absolute'
      }, position == 'left' && {left: sidePosition}, position == 'right' && {right: sidePosition}]}

    >
      <TouchableOpacity onPress={onPress} style={{
        backgroundColor:'white',
        alignItems:'center',
        justifyContent: 'center',
        borderRadius:SIZE_TOP_BAR/2,
        width:SIZE_TOP_BAR,
        height:SIZE_TOP_BAR }}>
        {children}
      </TouchableOpacity>
    </View>
  );
};


